
import React, { useState, useEffect } from "react";
import styles from "./VenuePlannerShare.module.css";

const VenuePlannerShare = () => {
  const [copyStatus, setCopyStatus] = useState("idle");

  useEffect(() => {
    if (copyStatus === "idle") return;

    const timer = window.setTimeout(() => {
      setCopyStatus("idle");
    }, 2200);

    return () => window.clearTimeout(timer);
  }, [copyStatus]);

  const fallbackCopy = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";

    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    const successful = document.execCommand("copy");
    document.body.removeChild(textarea);

    if (!successful) throw new Error("Copy failed");
  };

  const handleCopy = async () => {
    const currentUrl = window.location.href;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(currentUrl);
      } else {
        fallbackCopy(currentUrl);
      }

      setCopyStatus("success");
    } catch {
      try {
        fallbackCopy(currentUrl);
        setCopyStatus("success");
      } catch {
        setCopyStatus("error");
      }
    }
  };

  const isCopied = copyStatus === "success";
  const hasError = copyStatus === "error";

  return (
    <aside className={styles.shareWidget} aria-label="Share venue page">
      <div className={styles.shareCard}>
        {/* Share icon on top */}
        <div className={styles.shareIcon} aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <circle
              cx="18"
              cy="5"
              r="3"
              stroke="currentColor"
              strokeWidth="1.8"
            />
            <circle
              cx="6"
              cy="12"
              r="3"
              stroke="currentColor"
              strokeWidth="1.8"
            />
            <circle
              cx="18"
              cy="19"
              r="3"
              stroke="currentColor"
              strokeWidth="1.8"
            />
            <path
              d="m8.7 10.5 6.6-4M8.7 13.5l6.6 4"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </div>

       
<button
  type="button"
  className={`${styles.copyButton} ${
    isCopied ? styles.copiedButton : ""
  }`}
  onClick={handleCopy}
  aria-label={isCopied ? "Link copied" : "Copy current venue page URL"}
  title={isCopied ? "Link copied!" : "Copy venue link"}
>
  {isCopied ? (
    <svg
      className={styles.checkIcon}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="m5 12 4 4L19 6"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      className={styles.shareArrow}
      viewBox="0 0 100 75"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M4 70 C7 35 25 18 53 18 H65 V3 L96 27 L65 51 V36 H53 C33 36 17 46 4 70 Z"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )}

  <span className={styles.copyText}>
    {isCopied ? "Copied!" : "Copy Link"}
  </span>
</button>


      </div>
    </aside>
  );
};

export default VenuePlannerShare;
